export const preventDefault = (event: any) => {
    event.preventDefault();
};
